import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { faqList } from '@/mocks/anime';

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于91动漫 - 正版高清动漫在线观看平台',
            description: '91动漫品牌介绍、口碑评价与联系方式。91动漫是深受动漫迷喜爱的在线观看平台，汇聚海量正版高清动漫资源。',
            url: 'https://www.91anime.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '91动漫',
              url: 'https://www.91anime.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqList.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-20 pb-12 bg-background-100 border-b border-background-200/70">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: '关于我们' },
                ]}
              />
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-4 mb-2">
                关于91动漫
              </h1>
              <p className="text-sm text-foreground-500">
                正版高清动漫在线观看平台
              </p>
            </div>
          </div>

          <section className="py-14 md:py-20 bg-background-50" aria-labelledby="brand-title">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="max-w-[800px] mx-auto">
                <h2 id="brand-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                  品牌故事
                </h2>
                <div className="space-y-5 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    91动漫诞生于2018年，由一群热爱二次元文化的开发者共同创建。我们深知动漫爱好者对于高清画质、流畅播放以及第一时间看到最新番剧的渴望，因此决心打造一个专注于动漫内容的优质在线观看平台。
                  </p>
                  <p>
                    自成立以来，91动漫始终坚持正版路线，与国内外多家版权方建立了深度合作关系。我们不仅为用户提供海量的番剧资源，更注重播放体验的每一个细节——从画质优化到CDN加速，从UI设计到个性化推荐，力求为每一位二次元爱好者带来极致的追番体验。
                  </p>
                  <p>
                    如今，91动漫已发展成为国内领先的动漫在线观看平台之一，月活跃用户超过<strong>500万人</strong>，累计收录番剧<strong>超过3000部</strong>，涵盖热血、恋爱、奇幻、搞笑、悬疑、日常、战斗、科幻等多种类型。无论你是资深老宅还是刚入坑的新人，都能在91动漫找到属于自己的快乐。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100" aria-labelledby="stats-title">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="max-w-[900px] mx-auto">
                <h2 id="stats-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-10 text-center">
                  平台口碑
                </h2>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                  <div className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                    <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                      <i className="ri-user-smile-line text-2xl"></i>
                    </div>
                    <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">500万+</p>
                    <p className="text-xs text-foreground-500 mt-1">月活跃用户</p>
                  </div>
                  <div className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                    <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                      <i className="ri-movie-line text-2xl"></i>
                    </div>
                    <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">3000+</p>
                    <p className="text-xs text-foreground-500 mt-1">收录番剧</p>
                  </div>
                  <div className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                    <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                      <i className="ri-star-line text-2xl"></i>
                    </div>
                    <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">4.9</p>
                    <p className="text-xs text-foreground-500 mt-1">用户评分</p>
                  </div>
                  <div className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                    <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                      <i className="ri-thumb-up-line text-2xl"></i>
                    </div>
                    <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">98%</p>
                    <p className="text-xs text-foreground-500 mt-1">好评率</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50" aria-labelledby="faq-title">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="max-w-[750px] mx-auto">
                <h2 id="faq-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-10 text-center">
                  常见问题
                </h2>
                <div className="space-y-3">
                  {faqList.map((faq, index) => (
                    <div
                      key={index}
                      className="rounded-xl border border-background-200/70 overflow-hidden"
                    >
                      <button
                        onClick={() => setOpenFaq(openFaq === index ? null : index)}
                        className="w-full flex items-center justify-between p-5 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
                        aria-expanded={openFaq === index}
                      >
                        <span className="text-sm font-medium text-foreground-950 pr-4">
                          {faq.question}
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 text-lg flex-shrink-0 ${
                            openFaq === index ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`transition-all duration-300 overflow-hidden ${
                          openFaq === index ? 'max-h-96' : 'max-h-0'
                        }`}
                      >
                        <div className="px-5 pb-5">
                          <p className="text-sm text-foreground-600 leading-relaxed">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100" aria-labelledby="contact-title">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="max-w-[600px] mx-auto text-center">
                <h2 id="contact-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500 mb-8">
                  如您在使用过程中遇到任何问题，或有合作意向，欢迎通过以下方式与我们联系
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                  <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <p className="text-xs font-medium text-foreground-950 mb-1">电子邮箱</p>
                    <p className="text-xs text-foreground-500">support@91anime.com</p>
                  </div>
                  <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <p className="text-xs font-medium text-foreground-950 mb-1">客服电话</p>
                    <p className="text-xs text-foreground-500">400-888-9191</p>
                  </div>
                  <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <p className="text-xs font-medium text-foreground-950 mb-1">公司地址</p>
                    <p className="text-xs text-foreground-500">上海市浦东新区张江高科技园区</p>
                  </div>
                </div>
                <p className="text-xs text-foreground-400">
                  工作时间：周一至周五 9:00 - 18:00（法定节假日除外）
                </p>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}